import CopyEntityDialog from './CopyEntityDialog';

export default CopyEntityDialog;
